import {isDevXd}        from "@Common/ui-components/debug/is-dev";
import {setNestedValue} from "@Common/utils/arr-path";
import {buildUrlQuery}  from "@Common/utils/build-url-query";

import {formatText} from "../tools/format-text";

import {getBindingResults} from "./get-binding-results";
import {cascadeCollect}  from "@Common/utils/cascade";
import {decimalToBase64} from "@Common/utils/strings";

// sourceData is not mutated
// bindingData is not mutated
// templateConfig is not mutated
// overrideData is not mutated
// customFieldsData is not mutated
// ccJson is not mutated
export const mapBindingData = async (
    sourceData, templateBindingData, templateConfig, ccApis, overrideData, customFieldsData, ccJson, host, idOrder,
    mergeFields, qrCodeLineItemValue, qrCodeUrlValue
) => {

    isDevXd() ? console.log("templateBindingData ", templateBindingData):  null;
    isDevXd() ? console.log("templateConfig ", templateConfig) : null;

    // templateBindingData = {Front: {name: {type,value}}}
    const allItems = cascadeCollect(templateBindingData, "[*][*]", (_, {0:surface, 1:name}) => {
        if (customFieldsData?.[surface]?.some( (field) => field.name === name )) {
            return null;
        }

        return {surface,name};
    });

    const data = await getBoundData(
        allItems, sourceData, templateBindingData, templateConfig, ccApis.checkImages, overrideData, ccJson, host,
        idOrder, mergeFields, qrCodeLineItemValue, qrCodeUrlValue
    );
    isDevXd() ? console.log("DATA1", data): null;
    return data ;
};

const getImageCheckFromUrl = (url, checkedImages) => {
    return checkedImages.find( (image) => image?.url === url);
}

//Stores which URLs have been checked to minimize the number of API calls made.
const memoizeCheckImages = async (checkImages, imageUrls, checkedImages) => {

    let newUrls = [];
    for (const item of imageUrls) {
        if(!getImageCheckFromUrl(item, checkedImages)) {
            newUrls.push({"url": item});
        }
    }
    if(newUrls.length > 0) {
        return [
            ...checkedImages??[],
            ...await checkImages(newUrls),
        ];
    }
    return checkedImages;
}

// items is not mutated
// sourceData is not mutated
// templateBindingData is not mutated
// templateConfig is not mutated
// overrideData is not mutated
// ccJson is not mutated
// host is not mutated
const getBoundData = async (
    items, sourceData, templateBindingData, templateConfig, checkImages, overrideData, ccJson, host, idOrder, mergeFields,
    qrCodeLineItemValue, qrCodeUrlValue
) => {
    let templateImageFields = [];
    // Create array for image fields to be bound with listing images & sort for expected order.
    Object.keys(templateBindingData).forEach( (sideName) => {
        const sideInBindingData = templateBindingData[sideName];
        Object.keys(sideInBindingData).forEach( fieldName => {
            let fieldInBindingData = sideInBindingData[fieldName];
            if (fieldInBindingData?.type === "image" && fieldInBindingData.value?.includes('xd.listing.pictures.')) {
                templateImageFields.push({
                    side: sideName,
                    itemName: fieldName,
                    position: parseInt(fieldInBindingData.value.replace(/\D/g, '')),
                    linkId: ccJson?.[sideName]?.[fieldName]?.['placeholderLinkId']
                });
            }
        });
    });
    templateImageFields.sort( (a,b) => (a.position < b.position) ? -1 : (a.position > b.position) ? 1 : 0  );

    // add variable data merge tags to source data to prevent being replaced with blank values
    if(mergeFields) {
        for (const mergeField of mergeFields) {
            sourceData = setNestedValue(sourceData, mergeField.mergeField.replace(/[{}]/g, '').split('.'), mergeField.mergeField);
        }
    }

    let imagePlaceholder = [];
    let imageApiTest =[];
    let boundData:any = {};
    items?.forEach( (item) => {
        try {
            let itemSurface = item.surface;

            const bindingValue = templateBindingData[itemSurface]?.[item.name];
            const mask = templateConfig[itemSurface][item.name]?.['inputMask'];
            if (bindingValue && (bindingValue['value'] || bindingValue['type'] === 'qrCode')) {
                if (bindingValue['type'] === "standardVariable") {
                    let overrideValue = '';
                    if(overrideData && Object.keys(overrideData).length){
                        overrideValue = getBindingResults(overrideData, bindingValue['value']);
                    }
                    isDevXd() ? console.log("overrideValue",overrideValue): null;
                    if(overrideValue) {
                        boundData = setNestedValue(boundData, ["surfaces", itemSurface, item.name], formatText(mask, overrideValue));
                    }
                    else {
                        boundData = setNestedValue(boundData, ["surfaces", itemSurface, item.name], formatText(mask, getBindingResults(sourceData, bindingValue['value'])));
                    }
                }
                else if(bindingValue['type'] === 'inlineVariable') {
                    boundData = setNestedValue(boundData, ["surfaces", itemSurface, item.name], formatText(mask, getBindingResults(sourceData, bindingValue['value'])));
                }
                else if (bindingValue['type'] === 'image' && !bindingValue['value'].includes('xd.listing.pictures.') ) {
                    let imageUrl = getBindingResults(sourceData, bindingValue['value']);

                    imageApiTest.push(imageUrl);
                    imagePlaceholder.push({"side": itemSurface, "itemName": item.name})
                }
                else if(bindingValue['type'] === 'qrCode') {
                    let qrTypes = templateBindingData[itemSurface]?.[item.name]?.['qrType'] ?? [''];
                    //if the product line item isn't available or isn't included in qrCode available types, use the first as default.
                    let qrType = qrTypes.includes(qrCodeLineItemValue) ? qrCodeLineItemValue : qrTypes[0];
                    let qrValues = templateBindingData[itemSurface]?.[item.name]?.['qr'] ?? [];

                    Object.entries(qrValues).forEach(([qrValueName, value])=>{
                        boundData = setNestedValue(boundData, ["qrValues", itemSurface, item['name'], qrValueName], getBindingResults({...sourceData}, value));
                    });
                    let assignedDomain = templateBindingData[itemSurface]?.[item.name]?.qrPrefs?.['email']?.specifiedDomain ? (
                        sourceData?.xd?.templateOptions?.assignedDomain ??
                            sourceData?.xd?.office?.assignedDomain ??
                            sourceData?.xd?.company?.prefs?.assignedDomain ?? ''
                        ) : '';
                    let email = boundData?.qrValues?.[itemSurface]?.[item['name']]?.email ?? ''
                    if( email && assignedDomain ) {
                        email = email.split('@')[0];
                        if( email ) {
                            email = email + assignedDomain;
                        }
                    }
                    let prefix = templateBindingData[itemSurface]?.[item.name]?.qrPrefs?.['url']?.prefix;
                    let url = boundData?.qrValues?.[itemSurface]?.[item['name']]?.url ?? '';
                    if( url && prefix ) {
                        url = prefix + url;
                    }
                    if( qrCodeUrlValue ) {
                        url = qrCodeUrlValue;
                    }
                    let qrData = '';
                    if(qrType === 'vcard') {
                        let missingRequired = false;
                        ['firstName', 'lastName', 'title', 'tel', 'fax', 'email', 'org', 'streetAddress', 'city', 'state', 'zip', 'country'].forEach((value)=>{
                            if(!missingRequired && templateBindingData[itemSurface]?.[item.name]?.qrPrefs?.[value]?.isRequired
                                && !boundData?.qrValues?.[itemSurface]?.[item['name']]?.[value]) {
                                missingRequired = true;
                            }
                        });
                        if(!missingRequired) {
                            qrData = "BEGIN:VCARD%0AVERSION:3.0%0A" +
                                "FN:" + (qrValues.firstName ?? '') + " " + (qrValues.lastName ?? '') + "%0A" +
                                "N:" + (qrValues.lastName ?? '')  + ";" + (qrValues.firstName ?? '') + "%0A" +
                                "TITLE:" + (qrValues.title ?? '') + "%0A" +
                                "TEL;type=WORK;type=VOICE;type=pref:" + (qrValues.tel ?? '')  + "%0A" +
                                "TEL;type=WORK;type=FAX:" + (qrValues.fax ?? '')  + "%0A" +
                                "EMAIL;type=INTERNET;type=WORK;type=pref:" + (email ?? '') + "%0A" +
                                "ORG:" + (qrValues.org ?? '') + "%0A" +
                                "ADR;type=WORK;type=pref:;;" + (qrValues.streetAddress ?? '') + ";" + (qrValues.city ?? '') +
                                ";" + (qrValues.state ?? '') + ";" + (qrValues.zip ?? '') + ";" + (qrValues.country ?? '') + "%0A" +
                                "URL;type=WORK;type=pref:" + (url ?? '') + "%0AEND:VCARD";
                        }
                    }
                    else if( ( ['homevalue', 'xpresslinks'].includes(qrType) || ( qrType === 'url' && qrCodeUrlValue ) ) && idOrder) {
                        qrData = `${window.location.origin}/next/track.php?c=${sourceData?.xd?.company?.idCompany}&o=${decimalToBase64(idOrder)}&p=1`;
                    }
                    else if(qrType === 'url' && url) {
                        qrData = url;
                    }

                    if(qrData) {
                        const data = getBindingResults(sourceData ?? {}, qrData);
                        let imageUrl = `${host}/xdapi/api/create-qr${buildUrlQuery({data})}`;
                        boundData = setNestedValue(boundData, ["surfaces", itemSurface, item['name']], imageUrl);
                        boundData = setNestedValue(boundData, ["qrValues", 'tracking'], qrType === 'url' ? {
                            redirectType: qrType, redirectUrl: url
                        } : {
                            redirectType: qrType
                        });
                    }
                }
                else if(bindingValue['type'] === 'qrCodeLineItem') {
                    if( qrCodeLineItemValue ) {
                        let qrType = qrCodeLineItemValue;
                        let qrData = '';
                        if( ( ['homevalue', 'xpresslinks'].includes(qrType) || ( qrType === 'url' && qrCodeUrlValue ) ) && idOrder ) {
                            qrData = `${window.location.origin}/next/track.php?c=${sourceData?.xd?.company?.idCompany}&o=${decimalToBase64(idOrder)}&p=1`;
                        }
                        if(qrData) {
                            const data = getBindingResults(sourceData ?? {}, qrData);
                            let imageUrl = `${host}/xdapi/api/create-qr${buildUrlQuery({data})}`;
                            boundData = setNestedValue(boundData, ["surfaces", itemSurface, item['name']], imageUrl);
                            boundData = setNestedValue(boundData, ["qrValues", 'tracking'], qrType === 'url' ? {
                                redirectType: qrType, redirectUrl: qrCodeUrlValue
                            } : {
                                redirectType: qrType
                            });
                        }
                    }
                }
            }
        }
        catch (e) {
            console.log("Error with binding data for item: ", item);
            console.log(e);
        }
    });

    let checkedImages = [];
    //Gather a list of broken images.
    checkedImages = await memoizeCheckImages(checkImages, imageApiTest, checkedImages);
    const imageApiTestTemp = imageApiTest;
    const imagePlaceholderTemp = imagePlaceholder;
    imageApiTest = [];
    imagePlaceholder = [];
    for(let i=0; i<imagePlaceholderTemp.length; i++) {
        if(checkedImages[i]?.['available']){
            imagePlaceholder.push(imagePlaceholderTemp[i]);
            imageApiTest.push(imageApiTestTemp[i]);
        }
    }

    imagePlaceholder.forEach((item, index)=>{
        if(getImageCheckFromUrl(imageApiTest[index], checkedImages)['available']) {
            boundData = setNestedValue(boundData, ["surfaces", item.side, item.itemName], imageApiTest[index]);
        }
    });

    checkedImages = [];

    let checkedImagesArray = [];
    let usedListingImages = [];
    // Loop through listing images, check for good response & push good images to array "usedListingImages".
    //Break once enough good images available to match fields. Ready for binding.
    for (let i = 0; i < (sourceData?.xd?.listing?.pictures?.length ?? 0); i++) {
        checkedImagesArray.push(sourceData.xd.listing.pictures[i].pictureUrl)
        checkedImages = await memoizeCheckImages(checkImages, checkedImagesArray, checkedImages);
        if(checkedImages?.[i]?.available) {
            usedListingImages.push(checkedImages[i]);
        }
        if(usedListingImages.length === templateImageFields.length) {
            break;
        }
    }

    let index = 0;
    let linkIdFields = {};
    //Bind the final images.
    for( const item of templateImageFields ) {
        if(item.linkId in linkIdFields) {
            boundData = setNestedValue(boundData, ["surfaces", item.side, item.itemName], linkIdFields[item.linkId]);
        }
        else if(usedListingImages[index]) {
            boundData = setNestedValue(boundData, ["surfaces", item.side, item.itemName], usedListingImages[index]['url']);
            if(item.linkId){
                linkIdFields[item.linkId] = usedListingImages[index]['url'];
            }
            index++;
        }
    }

    return boundData;
};